module.exports = __webpack_public_path__ + "img/zc2.c9d394c6.png";